<template>
  <div
    :class="className"
    :style="{ height: height, width: width }"
  />
</template>

<script>
import * as echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import { debounce } from '@/utils/util'
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      default: () => { return {} }
    },
    title: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        this.setOptions(val)
      }
    }
  },
  mounted () {
    this.initChart()
    if (this.autoResize) {
      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 100)
      window.addEventListener('resize', this.__resizeHandler)
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 600)
    }
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler)
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    setOptions ({ locationDescription, electrifiedPotential, voff, limitMax1, limitMax2, limitMin1, limitMin2 } = {}) {
      this.chart.setOption({
        title: {
          text: name + '电位(v)'
        },
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {}
          }
        },
        legend: {},
        // toolbox: {
        //   show: true,
        //   feature: {
        //     dataZoom: {
        //       yAxisIndex: 'none'
        //     },
        //     dataView: { readOnly: false },
        //     magicType: { type: ['line', 'bar'] },
        //     restore: {},
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: locationDescription
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}V'
          }
        },
        dataZoom: [
          {
            type: 'slider',
            show: true,
            xAxisIndex: [0],
            handleSize: 0, //滑动条的 左右2个滑动条的大小
            height: 10, //组件高度
            left: 550, //左边的距离
            right: 540, //右边的距离
            bottom: 506, //右边的距离
            handleColor: '#ddd' //h滑动图标的颜色
          },
          {
            type: 'inside',
            start: 0,
            end: 50,
            textStyle: {
              color: '#fff'
            }
          },
          {
            show: true,
            type: 'slider',
            // y: '94%',
            bottom: '0',
            start: 0,
            end: 50,
            textStyle: {
              color: '#fff'
            }
          }
        ],
        series: [
          {
            name: '断电电位(本次)',
            type: 'line',
            data: voff,
            // markPoint: {
            //   data: [
            //     { type: 'max', name: '最大值' },
            //     { type: 'min', name: '最小值' }
            //   ]
            // },
            // markLine: {
            //   data: [
            //     { type: 'max', name: '最大值' },
            //     { type: 'min', name: '最小值' }
            //   ],
            //   label: {
            //     formatter: '{b}: {c}'
            //   }
            // },
            markLine: {
              silent: true,
              lineStyle: {
                normal: {
                  type: 'dashed',
                  color: '#fdd2d2' // 这儿设置安全基线颜色
                }
              },
              data: [
                {
                  yAxis: limitMin1
                },
                {
                  yAxis: limitMax1
                }
              ],
              label: {
                normal: {
                  formatter: '' // 这儿设置安全基线
                }
              }
            }
          },
          {
            name: '通电电位(本次)',
            type: 'line',
            data: electrifiedPotential,
            // markPoint: {
            //   data: [
            //     { type: 'max', name: '最大值' },
            //     { type: 'min', name: '最小值' }
            //   ]
            // },
            markLine: {
              silent: true,
              lineStyle: {
                normal: {
                  type: 'dashed',
                  color: '#fdd2d2' // 这儿设置安全基线颜色
                }
              },
              data: [
                {
                  yAxis: limitMin2
                },
                {
                  yAxis: limitMax2
                }
              ],
              label: {
                normal: {
                  formatter: '' // 这儿设置安全基线
                }
              }
            }
          }
        ]
      })
    },
    initChart () {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    }
  }
}
</script>
